import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UserProvider } from '../user/user';
import { ContribuaProvider } from '../contribua/contribua';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators'
import { LoadingController } from '@ionic/angular';
import { History } from 'src/app/interfaces/meeting.interface';
import { PerfilProfissional } from 'src/app/interfaces/perfil-profissional';

@Injectable({ providedIn: 'root' })
export class PessoaProvider {

  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;

  constructor(
    public http: HttpClient,
    public userProvider: UserProvider,
    public ContribuaProvider: ContribuaProvider,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
  ) {
  }

  possuiSolicitacao(idPessoa: any, tipo: string, idGrupo: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/possui-solicitacao',
      { idPessoa: idPessoa, tipo: tipo, idGrupo: idGrupo }
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getAniversariantes(idInstituicaoFiltro: any) {
    return this.http.get<any>(this.baseUrl + '/aniversariantes/aniversariantes-do-dia', {
      params: {'idInstituicao': idInstituicaoFiltro }
    })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getAniversariantesMes(idInstituicaoFiltro: any) {
    return this.http.get<any>(this.baseUrl + '/aniversariantes/aniversariantes-mes', {
      params: {'idInstituicao': idInstituicaoFiltro }
    })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getbyId(idPessoa: any) {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-by-id', {
      params: { expand: 'contato,endereco,hasMda,qtdministerios,qtdgrupos,apiKey,instituicao', 'id': idPessoa }
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getFamiliaresbyId(idPessoa: any) {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-familiares-by-id', {
      params: { 'id': idPessoa }
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getPessoasProfissao(idProfissao: any) {
    return this.http.get<any>(this.baseUrl + '/pessoa/pessoas-profissao', {
      params: { 'idProfissao': idProfissao }
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getFamiliaresAutorizados() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-familiares-autorizados').pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getFamiliaresAutorizadosById(idPessoa: any) {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-familiares-autorizados-by-id', { params: { idPessoa: idPessoa } }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getStatusPessoa(idPessoa: any) {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-status-pessoa', {
      params: { 'idPessoa': idPessoa }
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getTipoPessoa() {
    return this.http.post<any>(this.baseUrl + '/pessoa/get-tipo-pessoa', {})
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getPessoaFuncao() {
    return this.http.get<any>(this.baseUrl + '/pessoa/pessoa-funcao')
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getSubtipoPessoa(idTipo: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/get-subtipo-pessoa', { idTipo: idTipo })
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getTipoMembro() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-tipo-membro').pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getTipoVisitante() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-tipo-visitante').pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getTipoOcorrencia() {
    return this.http.get<any>(this.baseUrl + '/pessoa/tipo-ocorrencia').pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  /**
   * Verifica se CPF inserido é valido
   * 
   * @param string $cpf numero do cpf
   * @param string $nome nome
   * @return 
   */
  public cpfValido(cpf: any, nome: any) {
    var loader: any = this.loadingCtrl.create({ message: this.translate.instant('Carregando') });
    loader.present();
    return this.http.post<any>(
      this.baseUrl + '/pessoa/cpf-valido', {
      'cpf': cpf,
      'idInstituicao': this.ContribuaProvider.idInstituicao,
      'nome': nome
    }
    ).pipe(
      finalize(() => loader.dismiss())
    ).pipe(map(resposta => {
      return resposta;
    }));
  }

  public cpfValidoNovo(cpf: any, idPessoa: any) {
    // var loader: any = this.loadingCtrl.create({ message: this.translate.instant('Carregando') });
    // loader.present();
    return this.http.post<any>(
      this.baseUrl + '/pessoa/cpf-valido-novo', {
      'cpf': cpf,
      'idInstituicao': this.ContribuaProvider.idInstituicao,
      'id': idPessoa
    }
    ).pipe(
      // finalize(() => loader.dismiss())
    ).pipe(map(resposta => {
      return resposta;
    }));
  }


  /**
   * Verifica se CPF já esta cadastrado na base de dados
   * Author: Fernando Binasco
   */
  public cpfCadastrado(cpf: any) {
    return this.http.post<any>(
      this.baseUrl + '/pessoa/cpf-cadastrado', {
      'cpf': cpf,
      'idInstituicao': this.ContribuaProvider.idInstituicao
    }
    ).pipe(map(resposta => {
      return resposta;
    }));
  }

  getPessoas(filtro: {
    q: any;
    t: any;
    idGrupo: string | number | boolean | readonly (string | number | boolean)[];
    idOperacao: string | number | boolean | readonly (string | number | boolean)[];
    idade: string | number | boolean | readonly (string | number | boolean)[];
    idDependente: string | number | boolean | readonly (string | number | boolean)[];
    recadastro: string | number | boolean | readonly (string | number | boolean)[];
    pendente: boolean | readonly (boolean)[];
    id: any;
    filtroInstituicaoMultiIgreja: boolean | readonly (boolean)[];
    isOracao: boolean | readonly (boolean)[];
    idInstituicaoFiltroOvelhinha: any;
    isPessoasSemGrupo: boolean | readonly (boolean)[];
    isPessoasSemGrupoReuniao: boolean | readonly (boolean)[];
    participante: boolean | readonly (boolean)[];
  }, pag: { currentPage: any; }) {
    return this.http.get<any>(this.baseUrl + '/pessoa/buscar',
      {
        observe: 'response', params:
        {
          "expand": "contato",
          "page": pag.currentPage,
          "per-page": "10",
          "q": filtro.q,
          "t": filtro.t,
          "idGrupo": filtro.idGrupo ? filtro.idGrupo : '',
          "idOperacao": filtro.idOperacao ? filtro.idOperacao : '',
          "idade": filtro.idade ? filtro.idade : '',
          "idDependente": filtro.idDependente ? filtro.idDependente : '',
          "recadastro": filtro.recadastro ? filtro.recadastro : '',
          "pendente": filtro.pendente ? filtro.pendente : '',
          "id": filtro.id ? filtro.id : '',
          "filtroInstituicaoMultiIgreja": filtro.filtroInstituicaoMultiIgreja ? filtro.filtroInstituicaoMultiIgreja : false,
          "isOracao": filtro.isOracao ? filtro.isOracao : false,
          "idInstituicaoFiltroOvelhinha": filtro.idInstituicaoFiltroOvelhinha ? filtro.idInstituicaoFiltroOvelhinha : '',
          "isPessoasSemGrupo": filtro.isPessoasSemGrupo ? filtro.isPessoasSemGrupo : '',
          "isPessoasSemGrupoReuniao": filtro.isPessoasSemGrupoReuniao ? filtro.isPessoasSemGrupoReuniao : '',
          "participante": filtro.participante ? filtro.participante : '',
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          pessoas: data.body,
          pagination: pag
        };
      }));
  }

  getVisitantes(filtro: { q: any; t: any; }, pag: { currentPage: any; }) {
    return this.http.get<any>(this.baseUrl + '/pessoa/buscar-visitante',
      {
        observe: 'response', params:
        {
          "expand": "contato",
          "page": pag.currentPage,
          "per-page": "10",
          "q": filtro.q,
          "t": filtro.t
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          pessoas: data.body,
          pagination: pag
        };
      }));
  }

  getProfissoes(filtro: any, pag: { currentPage: any; }) {
    return this.http.get<any>(this.baseUrl + '/pessoa/profissoes',
      {
        observe: 'response', params:
        {
          "page": pag.currentPage,
          "per-page": "10",
          "filtro": filtro
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          profissoes: data.body,
          pagination: pag
        };
      }));
  }

  getContatos(filtro: any, pag: { currentPage: any; }) {
    return this.http.get<any>(this.baseUrl + '/pessoa/contatos',
      {
        observe: 'response', params:
        {
          "page": pag.currentPage,
          "per-page": "10",
          "filtro": filtro
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          contatos: data.body,
          pagination: pag
        };
      }));
  }

  addProfissao(profissao: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/add-profissao',
      { 'profissao': profissao }
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  criarPessoa(pessoa: any) {
    return this.http.post<any>(this.baseUrl + '/adm/add-pessoa',
      pessoa
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  buscarMigracaoConfiguracao() {
    return this.http.get<any>(this.baseUrl + '/pessoa/buscar-migracao-configuracao').pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  updatePessoaContato(idPessoa: any, pessoa: any, contato: any) {
    return this.http.post<any>(this.baseUrl + '/adm/update-pessoa-contato',
      { 'id': idPessoa, 'pessoa': pessoa, 'contato': contato }
    ).pipe(map(data => {
      if (!data.error) {
        this.userProvider.atualizarDadosPessoa().subscribe(() => { });
        return data;
      } else {
        return false;
      }
    }));
  }

  salvarEndereco(endereco: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/endereco',
      endereco
    ).pipe(map(data => {
      if (!data.error) {
        this.userProvider.atualizarDadosPessoa().subscribe(() => { });
        return data;
      } else {
        return false;
      }
    }));
  }

  salvarEnderecoGoogle(idEndereco: any, enderecoCompleto: string, idPais: any, objEndereco: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/endereco-google',
      { idEndereco: idEndereco, formatado: enderecoCompleto, idPais: idPais, objEndereco: objEndereco }
    ).pipe(map(data => {
      if (!data.error) {
        this.userProvider.atualizarDadosPessoa().subscribe(() => { });
        return data;
      } else {
        return false;
      }
    }));
  }

  updateFoto(base64: any, idPessoa: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/upload-foto',
      { foto: base64, idPessoa: idPessoa }
    ).pipe(map(data => {
      if (!data.error) {
        this.userProvider.atualizarDadosPessoa().subscribe(() => { });
        return data;
      } else {
        return false;
      }
    }));
  }

  updateFotoPessoaSemId(base64: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/upload-foto-pessoa-sem-id',
      { foto: base64 }
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  migrarCadastro(cadastro: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/migrar-cadastro',
      cadastro
    ).pipe(map(data => {
      return data;
    }));
  }

  migrarGrupos(idPessoa: any, idTipoPessoa: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/search-pessoa-grupo',
      { idPessoa: idPessoa, idTipoPessoa: idTipoPessoa }
    ).pipe(map(data => {
      return data;
    }));
  }

  criarAnotacao(entidade: any, idEntidade: any, anotacao: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/criar-anotacao',
      { entidade: entidade, idEntidade: idEntidade, anotacao: anotacao }
    ).pipe(map(data => {
      return data;
    }));
  }

  editAnotacao(id: any, anotacao: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/edit-anotacao',
      { id: id, anotacao: anotacao }
    ).pipe(map(data => {
      return data;
    }));
  }

  getAnotacao() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-anotacoes').pipe(map(data => {
      return data;
    }));
  }

  getBuscaGrupos(filtro: { q: any; idGrupo: any; dayMonth: any; participante: any; }, pag: { currentPage: any; }) {
    return this.http.get<any>(this.baseUrl + '/aniversariantes/busca-grupos', {
      observe: 'response', params:
      {
        "page": pag.currentPage,
        "per-page": "10",
        "q": filtro.q,
        "idGrupo": filtro.idGrupo,
        'dayMonth': filtro.dayMonth,
        'participante': filtro.participante,
      }
    }).pipe(map(data => {
      let pag = {
        currentPage: data.headers.get("X-Pagination-Current-Page"),
        pageCount: data.headers.get("X-Pagination-Page-Count"),
        perPage: data.headers.get("X-Pagination-Per-Page"),
        totalCount: data.headers.get("X-Pagination-Total-Count"),
      };
      return {
        grupos: data.body,
        pagination: pag
      };
    }));
  }

  getTokenTemp(idPessoa: any) {
    return this.http.get<any>(this.baseUrl + '/pessoa/token-temp', {
      params: { 'idPessoa': idPessoa }
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  salvarRecadastramento(dados: any, idPessoa: any, tipo: any) {
    return this.http.put<any>(this.baseUrl + '/pessoa/salvar-recadastramento',
      { dados: dados, idPessoa: idPessoa, tipo: tipo }
    ).pipe(map(data => {
      return data;
    }));
  }

  registrarAceite(tokenpush: any) {
    return this.http.post<any>(this.baseUrl + '/pessoa/registrar-aceite', { tokenpush: tokenpush })
      .pipe(map(data => {
        if (!data.error) {
          this.userProvider.atualizarDadosPessoa().subscribe(() => { });

          return data;
        } else {
          return false;
        }
      }));
  }

  salvarLogVideo(videos: string) {
    return this.http.post<any>(this.baseUrl + '/pessoa/salvar-log-video',
      { videos: videos }
    ).pipe(map(data => {
      return !data.error ? data : false;
    }));
  }

  getAviso(tipo: any) {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-aviso', {
      params: { 'tipo': tipo }
    }
    ).pipe(map(data => {
      return !data.error ? data : false;
    }));
  }

  getBuscaHistorico(uuid: any, pag: any) {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-busca-historico',
      {
        observe: 'response', params:
        {
          "expand": "total",
          "uuid": uuid,
          "page": pag.currentPage,
          "per-page": "10",
        }
      })
      .pipe(map(data => {
        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };

        return {
          historico: data.body,
          pagination: pag
        };
      }));
  }

  getStatusRecadastro() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-status-recadastro')
      .pipe(map(data => !data.error ? data : false));
  }

  getNotification() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-notification').pipe(map(data => {
      return data;
    }))
  }

  getLinkDonativos() {
    return this.http.get<any>(this.baseUrl + '/pessoa/link-donativos').pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }


  deleteNotification(idNotification: any) {
    return this.http.get<any>(this.baseUrl + '/pessoa/delete-notification', {
      params: { idNotification }
    }).pipe(map(data => {
      return !data.error ? data : false;
    }));
  }

  updateNotification(idNotification: any) {
    return this.http.get<any>(this.baseUrl + '/pessoa/update-notification', {
      params: { idNotification: idNotification },
    })
      .pipe(map(data => {
        return data;
      }));
  }

  updateNotificationAll() {
    return this.http.get<any>(this.baseUrl + '/pessoa/update-notification-all')
      .pipe(map(data => {
        return data;
      }));
  }
  
  getCountNotification() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-count-notification', {
      observe: 'response',
    })
      .pipe(map(data => {
        return data.body;
      }));
  }

  verifyIfIsPerson(id: any) {
    return this.http
      .get<any>(this.baseUrl + '/pessoa/verify-if-is-person', {
        params: {
          id: id,
        },
      })
      .pipe(map((data) => {
        return !data.error ? data : false;
      }));
  }

  getDocumentos(idPessoa: any) {
    return this.http
      .get<any>(this.baseUrl + "/pessoa/get-documentos", {
        observe: "response",
        params: {
          idPessoa: idPessoa,
        },
      })
      .pipe(
        map((data) => {
        return data.body;
      })
    );
  }

  postHistoricoPresenca(filtro: string) {
    return this.http.post<History[]>(this.baseUrl + '/pessoa/post-historico-presenca',
      { filtro: filtro }
    ).pipe(map(data => {
      return data;
    }));
  }
  
  getCarteirinhas(idPessoa: any) {
    return this.http
      .get<any>(this.baseUrl + "/pessoa/list-carteirinhas", {
        observe: "response",
        params: {
          idPessoa: idPessoa,
        },
      })
      .pipe(
        map((data) => {
        return data.body;
      })
    );
  }
}
